export default (set, promoProducts) => {
  set(() => ({
    allPromoProducts: { ...promoProducts }
  }),
  false,
  { type: 'groupedPromo/updateAllPromoProducts', data: promoProducts });
};
